import React, { useEffect, useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from "@material-ui/core/Grid";
import translate from '../other/translate.json';
import clsx from 'clsx';
import config from '../other/config';
const { serverAPI } = config;

const CustomTypography = withStyles((theme) => ({
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    fontWeight: '500',
    color: '#24262A'
  },

  body1: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: '400',
    color: '#8987A2'
  },

  gutterBottom: {
    marginBottom: 20
  },
}))(Typography);

export default function Cookie(props) {
  const classes = useStyles();
  const language = localStorage.getItem('language') || 'Ru'

  return (
    language === 'Ru'
      ?
      <Grid container>
        <CustomTypography variant="h1" gutterBottom>Согласие на обработку пользовательских данных</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>Продолжая использовать наш сайт, вы даёте согласие на обработку (в т.ч. с помощью метрических программ Google Analytics, Яндекс.Метрика, пикселей, скриптов и иных аналогичных по функционалу счетчиков рекламных систем) ваших пользовательских данных: файлов cookie,ip-адреса пользователя, id пользователя, сведений о местоположении, типе устройства, времени посещения страницы, сведений о ресурсах сети Интернет, с которых были совершены переходы на сайт <a href="https://catalog.cft.ru/" className={classes.LinkType2} target="_blank" rel="nofollow noopener">https://catalog.cft.ru/</a> и сведений о действиях пользователя на сайте <a href="https://catalog.cft.ru/" className={classes.LinkType2} target="_blank" rel="nofollow noopener">https://catalog.cft.ru/</a>.</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>Обработка пользовательских данных представляет собой предусмотренные Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, передачу, обезличивание, блокирование, удаление, уничтожение  данных и осуществляется АО ЦФТ и партнерами АО ЦФТ в целях полноценного функционирования сайта, проведения ретаргетинга, статистических исследований и обзоров, а также, с целью управления размещением рекламных материалов в сети Интернет.</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>Если вы не хотите, чтобы ваши данные обрабатывались, пожалуйста, ограничьте использование файлов cookie в своём браузере.</CustomTypography>
      </Grid>
      :
      <Grid container>
        <CustomTypography variant="h1" gutterBottom>Consent for processing of user data</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>By continuing to use our website, you consent to the processing, i.a. with metric tools by Google Analytics, Yandex.Metrica, pixels, scripts and other advertising system counters similar in functionality, of your user data: cookie files, user IP address, user ID, location data, device type, page visit time, data about Internet resources from which transitions to the website <a href="https://catalog.cft.ru/" className={classes.LinkType2} target="_blank" rel="nofollow noopener">https://catalog.cft.ru/</a> were made and data about user actions on the website <a href="https://catalog.cft.ru/" className={classes.LinkType2} target="_blank" rel="nofollow noopener">https://catalog.cft.ru/</a>.</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>Processing of user data is the collection, recording, systematization, accumulation, storage, clarification, extraction, use, transfer, depersonalization, blocking, deletion, destruction of data, as per Federal Law “On Personal Data” No. 152-FZ of July 27, 2006, which is carried out by CFT JSC and partners of CFT JSC for the purpose of the full functioning of the website, retargeting, statistical research and reviews, as well as managing the online placement of advertising materials.</CustomTypography>

        <CustomTypography variant="body1" gutterBottom>If you do not want your data to be processed, please limit the use of cookies in your browser.</CustomTypography>
      </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: '100%',
    backgroundColor: '#F6F6FB',
    borderRadius: 16,
    boxShadow: 'none',
    padding: 24,
    height: 'fit-content',

    [theme.breakpoints.down(696)]: {
      padding: 0,
      backgroundColor: 'transparent',
    }
  },

  LinkType2: {
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 400,
    color: '#8987A2',
    textDecoration: 'none',

    '&:hover': {
      color: '#24262A',
      textDecoration: 'none',
      borderBottom: '1px solid rgba(0, 0, 0, 0.4)',
    }
  },
}));